var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"header"},[_c('NavBar',{attrs:{"models":_vm.mainNav}}),_c('div',{staticClass:"container"},[_c('cnc-breadcrumbs')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }